import React, { Component } from 'react'
import { Card, Col, Row, Form, Button, Table, Spinner } from "react-bootstrap-v5";
import Select from "react-select";
import { AsyncTypeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { toast } from "react-toastify";
import { FaTrashAlt } from "react-icons/fa"
import * as JobOptions from '../../../../Function/defaultJobOptions'
import { retailerService } from '../../../../Services/retailerService'

class Retailer extends Component {

    state = {
        buttonSubmit: true,
        retailerOptions: [],
        retailerInvoices: [],
        isLoading: false,
        retailerObj: {}
    }

    componentDidMount() {
        if (this.props.jobId) {
            retailerService.getRetailerInvoices({ jId: this.props.jobId }).then(result => {
                if (result.status == true) {
                    this.setState({ retailerInvoices: result.data })
                }
            })
        }

    }
    callRerailerInvoice = ()=>{
        retailerService.getRetailerInvoices({ jId: this.props.jobId }).then(result => {
            if (result.status == true) {
                this.setState({ retailerInvoices: result.data })
            }
        })
    }
    handleSearch = (query) => {
        this.setState({ isLoading: true })
        retailerService.searchRetailer({ search: query }).then(result => {
            if (result.status == true) {
                this.setState({ retailerOptions: result.data })
            }
            this.setState({ isLoading: false })
        })
    }

    handleInputRName = (input) => {
        this.handleInputChange({ target: { name: 'retailer_name', value: input } })
    }

    handleSelectChnage = (e, type) => {
        let cargoType = JobOptions.cargoTypes().filter(item => e.value === item.value)
        // { value: "FURNITURE", label: "Furniture" }
        this.handleInputChange({ target: { name: type, value: cargoType } })
    }

    handleInputChange(e) {
        const { name, value } = e.target
        let rObj = this.state.retailerObj
        rObj[name] = value
        this.setState({ retailerObj: rObj })
    }

    handleChange = (selectedOptions) => {
        let rObj = this.state.retailerObj
        if (Array.isArray(selectedOptions) && selectedOptions[0]?.retailer_name) {
            this.handleInputChange({ target: { name: 'retailer_name', value: selectedOptions[0]['retailer_name'] } })
            this.handleInputChange({ target: { name: 'retailer_id', value: selectedOptions[0]['_id'] } })
        }
        let cargoType = JobOptions.cargoTypes().filter(item => selectedOptions[0].retailer_type === item.value)
        rObj.referral_token = selectedOptions[0].referral_token
        rObj.cargo_type = cargoType
        this.setState({ retailerObj: rObj })
    }

    addRetailer = () => {
        this.setState({ buttonSubmit: false })
        let psotRetailerObj = this.state.retailerObj
        psotRetailerObj.cargo_type =psotRetailerObj.cargo_type[0].value
        if (this.props.jobId) {
            psotRetailerObj.job_id = this.props.jobId
        }

        retailerService.addGuestRetailer(this.state.retailerObj).then(result => {
            if (result.status === true) {
                toast.success(result.message);
                const { jobData, onChangeValue } = this.props
                let obj = this.state.retailerObj
                let jdata = Array.isArray(jobData) ? jobData : []
                obj.retailer_id = result.data._id
                
                jdata.push(obj) // pushing obj in existing array
                
                onChangeValue({ value: jdata }, 'retailer_details', 'retailer_details')
                this.setState({ buttonSubmit: true ,retailerObj: {
                        retailer_name: "",
                        retailer_id: "",
                        referral_token: "",
                        cargo_type: "",
                        date: "",
                        invoice_value: "",
                        invoice_number: "",
                        comments: "",
                }})

                this.callRerailerInvoice();

            } else {
                toast.success(result.message);
                this.setState({ buttonSubmit: true })
            }
        })
    }

    handleRemoveItem = (itemid) => {
        let params = {id:itemid} 
        retailerService.deleteRetailerJob(params).then((res) => {
            if(res?.status){
                this.callRerailerInvoice();
                toast.success(res?.message)
            }
        })
    }


    filterBy = () => true;

    render() {
        const { retailerInvoices, retailerOptions, retailerObj, isLoading, buttonSubmit } = this.state
        const { onChangeValue } = this.props
        // console.log(this.state,'propsprops')
        let refCode,restCat;
        
        // if (!jobData || Object.keys(jobData).length === 0) return false

        return (
            <Card>
                <div className="card-header bg-light"><h4>Retailer Information</h4></div>
                <Card.Body>

                    <Row>
                        <Table striped bordered hover size="sm">
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Retailer Name</th>
                                    <th>Referral Code</th>
                                    <th>Invoice Number</th>
                                    <th>Invoice Value</th>
                                    <th>Cargo Type</th>
                                    <th>Comment</th>
                                    <th className='text-center'>Action</th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    retailerInvoices
                                    && Object.keys(retailerInvoices).length > 0
                                    && retailerInvoices.map((item, i) => {
                                        return <tr>
                                            <th>{i + 1}</th>
                                            <th>{item.retailer_name}</th>
                                            <th>{item.referral_token}</th>
                                            <th>{item.invoice_number}</th>
                                            <th>{item.invoice_value}</th>
                                            <th>{item.cargo_type}</th>
                                            <th>{item.comments}</th>
                                            <th className='text-center'> <Button
                                            variant="danger"
                                            size="sm"
                                            onClick={() => this.handleRemoveItem(item._id)}
                                        >
                                            <FaTrashAlt />
                                        </Button></th>

                                        </tr>
                                    })
                                }


                            </tbody>
                        </Table>
                    </Row>

                    <Row>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label>Retailer Name</Form.Label>

                                <AsyncTypeahead
                                    id="async-pagination-example"
                                    labelKey="retailer_name"
                                    isLoading={isLoading}
                                    minLength={3}
                                    name="retailer_name"
                                    onSearch={this.handleSearch}
                                    onChange={this.handleChange}
                                    onInputChange={this.handleInputRName}
                                    options={retailerOptions}
                                    placeholder="Search for Retailer..."
                                    renderMenuItemChildren={(option) => (
                                        <> 
                                            
                                            <span>{option.retailer_name}</span>
                                        </>
                                    )}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Referral Code</Form.Label>
                                <Form.Control
                                    name="referral_code"
                                    value={retailerObj?.referral_token}
                                    // onChange={(e) => onChangeValue(e, 'retailer_details')}
                                    onChange={(e) => this.handleInputChange(e)}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Invoice Number</Form.Label>
                                <Form.Control
                                    name="invoice_number"
                                    value={retailerObj?.invoice_number}
                                    onChange={(e) => this.handleInputChange(e)}
                                />
                            </Form.Group>

                        </Col>
                        <Col>
                            <Form.Group className="mb-3">
                                <Form.Label>Date</Form.Label>
                                <Form.Control
                                    name="date"
                                    type="date"
                                    value={retailerObj?.date}
                                    onChange={(e) => this.handleInputChange(e)}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Invoice Value</Form.Label>
                                <Form.Control
                                    type="number"
                                    name="invoice_value"
                                    value={retailerObj?.invoice_value}
                                    onChange={(e) => this.handleInputChange(e)}
                                />
                            </Form.Group>

                            <Form.Group className="mb-3">
                                <Form.Label>Cargo Type</Form.Label>
                                <Select
                                    value={retailerObj?.cargo_type}
                                    options={JobOptions.cargoTypes()}
                                    name="cargo_type"
                                    onChange={e => this.handleSelectChnage(e, 'cargo_type')}

                                />
                            </Form.Group>


                        </Col>

                        <div className="col-12">
                            <div className="">
                                <label className="form-label">Comment</label>
                                <textarea
                                    className="form-control form-control-sm"
                                    name="comments"
                                    value={retailerObj?.comments}
                                    onChange={(e) => this.handleInputChange(e)}
                                />
                            </div>

                        </div>



                    </Row>

                    <Row className='mt-3'>
                    {
                        !this.props.isview && 
                        <Col md={4}>
                            {buttonSubmit && <Button variant="warning" onClick={() => this.addRetailer()}>
                                Add Retailer
                            </Button>
                            }
                            {!buttonSubmit
                                && <Button variant="primary" disabled>
                                    <Spinner
                                        as="span"
                                        animation="grow"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />
                                    Loading...
                                </Button>
                            }
                        </Col>

                        
                    }
                        <Col md={{ span: 4, offset: 4 }}>

                        </Col>
                    </Row>
                </Card.Body>
            </Card>
        )
    }
}

export default Retailer